import { ILayoutState } from './types'

export const initialLayoutState: ILayoutState = {
  sidebar: {
    isOpen: true,
  },
}
